
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import ProtectedRoute from '../components/feature/ProtectedRoute';

const HomePage = lazy(() => import('../pages/home/page'));
const OnboardingPage = lazy(() => import('../pages/onboarding/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const RegistroPage = lazy(() => import('../pages/registro/page'));
const InicioPage = lazy(() => import('../pages/inicio/page'));
const SubirFacturaPage = lazy(() => import('../pages/subir-factura/page'));
const CalculadoraPage = lazy(() => import('../pages/calculadora/page'));
const EmpresasPage = lazy(() => import('../pages/empresas/page'));
const SolarPage = lazy(() => import('../pages/solar/page'));
const SolicitudesPage = lazy(() => import('../pages/solicitudes/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const PerfilPage = lazy(() => import('../pages/perfil/page'));
const ContactoPage = lazy(() => import('../pages/contacto/page'));
const PoliticaPrivacidadPage = lazy(() => import('../pages/politica-privacidad/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const SinFacturaPage = lazy(() => import('../pages/sin-factura/page'));
const PremiumPage = lazy(() => import('../pages/premium/page'));
const ServiciosLuzPage = lazy(() => import('../pages/servicios-luz/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const ArticlePage = lazy(() => import('../pages/blog/article/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/home',
    element: <HomePage />
  },
  {
    path: '/onboarding',
    element: <OnboardingPage />
  },
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    path: '/registro',
    element: <RegistroPage />
  },
  {
    path: '/inicio',
    element: <ProtectedRoute><InicioPage /></ProtectedRoute>
  },
  {
    path: '/subir-factura',
    element: <SubirFacturaPage />
  },
  {
    path: '/sin-factura',
    element: <SinFacturaPage />
  },
  {
    path: '/calculadora',
    element: <CalculadoraPage />
  },
  {
    path: '/empresas',
    element: <EmpresasPage />
  },
  {
    path: '/solar',
    element: <SolarPage />
  },
  {
    path: '/premium',
    element: <PremiumPage />
  },
  {
    path: '/servicios-luz',
    element: <ServiciosLuzPage />
  },
  {
    path: '/blog',
    element: <BlogPage />
  },
  {
    path: '/blog/:slug',
    element: <ArticlePage />
  },
  {
    path: '/solicitudes',
    element: <ProtectedRoute><SolicitudesPage /></ProtectedRoute>
  },
  {
    path: '/dashboard',
    element: <ProtectedRoute><DashboardPage /></ProtectedRoute>
  },
  {
    path: '/perfil',
    element: <ProtectedRoute><PerfilPage /></ProtectedRoute>
  },
  {
    path: '/contacto',
    element: <ContactoPage />
  },
  {
    path: '/politica-privacidad',
    element: <PoliticaPrivacidadPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
